import React from 'react';

const navigation = {
  solutions: [
    { name: 'Academic Class Spaces', href: '#' },
    { name: 'College Counselling', href: '#' },
    { name: 'Standardized Testing', href: '#' },
  ],
  tutors: [
    { name: 'Browse Tutors', href: '#' },
    { name: 'Spanish Tutors', href: '#' },
    { name: 'Math Tutors', href: '#' },
    { name: 'History Tutors', href: '#' },
    { name: 'English Tutors', href: '#' },
    { name: 'Apply as Tutor', href: '#' },
  ],
  company: [
    { name: 'About Us', href: '#' },
    { name: 'Careers', href: '#' },
    { name: 'Partnerships', href: '#' },
    { name: 'Privacy Policy', href: '#' },
    { name: 'Terms of Services', href: '#' },
  ],
  support: [
    { name: 'Contact Us', href: '#' },
    { name: 'Email Us', href: '#' },
    { name: 'Request a Feature', href: '#' },
  ],
};

const socials = [
  { name: 'LinkedIn', icon: '/social-media/LinkedinLogo.svg', href: '#' },
  { name: 'Facebook', icon: '/social-media/FacebookLogo.svg', href: '#' },
  { name: 'Twitter', icon: '/social-media/XLogo.svg', href: '#' },
  { name: 'Instagram', icon: '/social-media/InstagramLogo.svg', href: '#' },
];

const Footer = () => {
  return (
    <footer className="bg-white py-6">
      <div className="mx-auto flex max-w-7xl flex-col px-4">
        {/* Logo and Tagline */}
        <div className="flex items-center gap-5">
          <img
            src="/images/icons/logo.svg"
            alt="logo"
            className="h-auto w-[189px] object-contain"
          />
          <h2 className="inter text-lg font-medium italic leading-[32px] -tracking-[0.18px] text-[#044047]">
            I am always improving 🚀
          </h2>
        </div>

        {/* Navigation Grid */}
        <div className="flex flex-col items-start justify-between gap-8 md:flex-row md:gap-0">
          {/* Navigation Sections */}
          <div className="grid grid-cols-2 gap-8 text-left sm:flex sm:items-start sm:gap-12">
            {Object.keys(navigation).map((key) => (
              <FooterSection key={key} title={key} contents={navigation[key]} />
            ))}
          </div>

          {/* Newsletter */}
          <div className="order-2 flex w-full max-w-[343px] flex-col justify-center gap-4 rounded-3xl bg-[linear-gradient(136deg,#FFF_8.91%,#F7F7F7_50%)] p-6 lg:order-none">
            <h3 className="text-lg font-medium capitalize leading-[24px] -tracking-[0.18px] text-[#044047]">
              Subscribe to our Newsletter
              <br />
              for our latest updates
            </h3>
            <div className="flex flex-col gap-4">
              <input
                type="email"
                placeholder="Enter your Email Address"
                className="w-full rounded-2xl border border-[#DCDCDC] px-[18px] py-[14px] text-base font-medium -tracking-[0.16px]"
              />
              <button className="rounded-2xl border border-[#66CDCC] px-6 py-[14px] text-base text-[#66CDCC]">
                Subscribe
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="flex flex-col items-center justify-between gap-6 pt-9 md:flex-row">
          <p className="text-base font-normal leading-[32px] -tracking-[0.16px] text-[#678285]">
            © All rights reserved 2024
          </p>
          <div className="flex flex-col md:flex-row md:items-center md:gap-7">
            <span className="text-base font-normal leading-[32px] -tracking-[0.16px] text-[#678285]">
              Connect with us
            </span>
            <div className="flex gap-6">
              {socials.map((social) => (
                <a key={social.name} href={social.href} className="flex h-8 w-8">
                  <img
                    src={social.icon}
                    alt={social.name}
                    className="h-full w-full object-contain"
                  />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

function FooterSection({ title, contents }) {
  return (
    <div className="flex flex-col gap-[6px] pt-6">
      <h3 className="text-md font-medium capitalize leading-[32px] -tracking-[0.18px] text-[#044047]">
        {title}
      </h3>
      <ul className="flex flex-col gap-[6px]">
        {contents.map((item) => (
          <li key={item.name}>
            <a
              href={item.href}
              className="text-base font-normal capitalize leading-8 -tracking-[0.16px] text-[#678285]"
            >
              {item.name}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Footer;
